const vp = document.getElementById('ts-vp');
  const track_testi = document.getElementById('ts-track');
  const dotsWrap = document.getElementById('ts-dots');
  const cards_testi = Array.from(track_testi.querySelectorAll('.ts-card'));
  const N = cards_testi.length;
  let cur = 1, dragging = false, startX = 0, startY = 0, baseOff = 0, startT = 0;

  function cardW() { return cards_testi[0].offsetWidth + 20; }
  function sideOff() { return (vp.offsetWidth - cards_testi[0].offsetWidth) / 2; }
  function targetOff(i) { return -(i * cardW()) + sideOff(); }

  function goTo(i, anim = true) {
    cur = Math.max(0, Math.min(i, N - 1));
    if (!anim) track_testi.classList.add('no-trans'); else track_testi.classList.remove('no-trans');
    track_testi.style.transform = `translateX(${targetOff(cur)}px)`;
    cards_testi.forEach((c, j) => c.classList.toggle('activev1', j === cur));
    dotsWrap.querySelectorAll('.ts-dot').forEach((d, j) => d.classList.toggle('activev1', j === cur));
  }

  cards_testi.forEach((_, i) => {
    const d = document.createElement('button');
    d.className = 'ts-dot' + (i === cur ? ' activev1' : '');
    d.addEventListener('click', () => goTo(i));
    dotsWrap.appendChild(d);
  });

  goTo(cur, false);
  window.addEventListener('resize', () => goTo(cur, false));

  function onStart(x, y) {
    dragging = true; startX = x; startY = y; startT = Date.now();
    baseOff = targetOff(cur);
    track_testi.classList.add('no-trans');
    vp.classList.add('draggingv1');
  }
  function onMove(x) {
    if (!dragging) return;
    track_testi.style.transform = `translateX(${baseOff + (x - startX)}px)`;
  }
  function onEnd(x) {
    if (!dragging) return;
    dragging = false;
    vp.classList.remove('draggingv1');
    const dx = x - startX;
    const vel = Math.abs(dx) / (Date.now() - startT);
    const thresh = vel > 0.3 ? 20 : cardW() * 0.22;
    track_testi.classList.remove('no-trans');
    if (dx < -thresh) goTo(cur + 1);
    else if (dx > thresh) goTo(cur - 1);
    else goTo(cur);
  }

  vp.addEventListener('mousedown', e => { e.preventDefault(); onStart(e.clientX, e.clientY); });
  window.addEventListener('mousemove', e => { if (dragging) onMove(e.clientX); });
  window.addEventListener('mouseup', e => { if (dragging) onEnd(e.clientX); });
  vp.addEventListener('touchstart', e => { const t = e.touches[0]; onStart(t.clientX, t.clientY); }, { passive: true });
  vp.addEventListener('touchmove', e => { const t = e.touches[0]; onMove(t.clientX); }, { passive: true });
  vp.addEventListener('touchend', e => { const t = e.changedTouches[0]; onEnd(t.clientX); }, { passive: true });